module.exports = __webpack_public_path__ + "assets/img/Edito_Mathieu-Vedrenne_menu.a2d77267-ps.jpg";